import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAlP4I6-LwcsnqKGyUCJHwseAn3kNxnygE",
  authDomain: "chore-tracker-799cc.firebaseapp.com",
  projectId: "chore-tracker-799cc",
  storageBucket: "chore-tracker-799cc.firebasestorage.app",
  messagingSenderId: "784041579060",
  appId: "1:784041579060:web:d741d3ad35aaec82bc3061"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
